import { ITeamProfileConfiguration, IWeekDays, IWorkDay } from '@shared/services/teamProfiles.service';

const dayNames: (keyof IWeekDays)[] = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

/** Maps a date's day-of-week to the corresponding IWorkDay entry from the team profile's week days configuration. */
export function getWorkDayForDate(weekDays: IWeekDays, date: Date): IWorkDay {
	const dayName = dayNames[date.getDay()];
	return weekDays[dayName];
}

/** ActiveDate is a calendar date, so it must be compared as one. Parsing it as an instant reads it as UTC midnight, which lands on the wrong day for shifts starting just after local midnight. */
function toDayNumber(year: number, month: number, day: number): number {
	return year * 10000 + month * 100 + day;
}

function toActiveDayNumber(activeDate: string): number {
	const [year, month, day] = activeDate.split(/[^0-9]/).map(Number);
	return toDayNumber(year, month, day);
}

/** Returns the configuration with the most recent activeDate on or before the target date. Returns null if no configuration is active for the given date. */
export function getActiveConfiguration(configurations: ITeamProfileConfiguration[], date: Date): ITeamProfileConfiguration | null {
	const targetDay = toDayNumber(date.getFullYear(), date.getMonth() + 1, date.getDate());
	const sorted = configurations.filter((c) => toActiveDayNumber(c.activeDate) <= targetDay).sort((a, b) => toActiveDayNumber(b.activeDate) - toActiveDayNumber(a.activeDate));
	return sorted[0] ?? null;
}
